/**
 * normalize the country code in the user profile
 * it mainly converts the USA (potential from SF) to US (only accepted by the payment provider)
 */
export default (country) => {
    if (!country) {
        country = 'US';
    }
    return country.slice(0, 2);
};
